<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="24"
    height="24"
    :viewBox="`0 0 ${size} ${size}`"
  >
    <path :id="svgId" :d="svgItem[name].path" />
    <path v-if="svgItem[name].path2" :id="svgId" :d="svgItem[name].path2" />
  </svg>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    name: { type: String, default: null },
    param: { type: String, default: null },
  },
  data() {
    return {
      svgItem: {
        search: {
          path:
            "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z",
        },
        add: {
          path:
            "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
        },
        toggle: {
          path:
            "M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z",
        },
        menu: {
          path:
            "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z",
        },
        close: {
          path:
            "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
        },
        file: {
          path:
            "M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z",
        },
        paperclip: {
          path:
            "M16.5,6V17.5A4,4 0 0,1 12.5,21.5A4,4 0 0,1 8.5,17.5V5A2.5,2.5 0 0,1 11,2.5A2.5,2.5 0 0,1 13.5,5V15.5A1,1 0 0,1 12.5,16.5A1,1 0 0,1 11.5,15.5V6H10V15.5A2.5,2.5 0 0,0 12.5,18A2.5,2.5 0 0,0 15,15.5V5A4,4 0 0,0 11,1A4,4 0 0,0 7,5V17.5A5.5,5.5 0 0,0 12.5,23A5.5,5.5 0 0,0 18,17.5V6H16.5Z",
        },
        "close-outline": {
          path:
            "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
        },
        send: {
          path: "M2,21L23,12L2,3V10L17,12L2,14V21Z",
        },
        emoji: {
          path:
            "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z",
        },
        document: {
          path: "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z",
        },
        pencil: {
          path:
            "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z",
        },
        checkmark: {
          path: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
        },
        "double-checkmark": {
          path:
            "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z",
        },
        eye: {
          path:
            "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z",
        },
        dropdown: {
          path: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
        },
        deleted: {
          path:
            "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20A8,8 0 0,0 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z",
        },
        microphone: {
          size: "large",
          path:
            "M432.8,216.4v39.2c0,45.2-15.3,84.3-45.2,118.4c-29.8,33.2-67.3,52.8-111.6,57.9v40.9h78.4c5.1,0,10.2,1.7,13.6,6c4.3,4.3,6,8.5,6,13.6c0,5.1-1.7,10.2-6,13.6c-4.3,4.3-8.5,6-13.6,6H157.6c-5.1,0-10.2-1.7-13.6-6c-4.3-4.3-6-8.5-6-13.6c0-5.1,1.7-10.2,6-13.6c4.3-4.3,8.5-6,13.6-6H236v-40.9c-44.3-5.1-81.8-23.9-111.6-57.9s-45.2-73.3-45.2-118.4v-39.2c0-5.1,1.7-10.2,6-13.6c4.3-4.3,8.5-6,13.6-6s10.2,1.7,13.6,6c4.3,4.3,6,8.5,6,13.6v39.2c0,37.5,13.6,70.7,40,97.1s59.6,40,97.1,40s70.7-13.6,97.1-40c26.4-26.4,40-59.6,40-97.1v-39.2c0-5.1,1.7-10.2,6-13.6c4.3-4.3,8.5-6,13.6-6c5.1,0,10.2,1.7,13.6,6C430.2,206.2,432.8,211.3,432.8,216.4z M353.5,98v157.6c0,27.3-9.4,50.3-29,69c-19.6,19.6-42.6,29-69,29s-50.3-9.4-69-29c-19.6-19.6-29-42.6-29-69V98c0-27.3,9.4-50.3,29-69c19.6-19.6,42.6-29,69-29s50.3,9.4,69,29C344.2,47.7,353.5,71.6,353.5,98z",
        },
        "audio-play": {
          size: "medium",
          path:
            "M43.331,21.237L7.233,0.397c-0.917-0.529-2.044-0.529-2.96,0c-0.916,0.528-1.48,1.505-1.48,2.563v41.684   c0,1.058,0.564,2.035,1.48,2.563c0.458,0.268,0.969,0.397,1.48,0.397c0.511,0,1.022-0.133,1.48-0.397l36.098-20.84   c0.918-0.529,1.479-1.506,1.479-2.564S44.247,21.767,43.331,21.237z",
        },
        "audio-pause": {
          size: "medium",
          path:
            "M17.991,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C4.729,2.969,7.698,0,11.36,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z",
          path2:
            "M42.877,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C29.616,2.969,32.585,0,36.246,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z",
        },
      },
    };
  },
  computed: {
    svgId() {
      const param = this.param ? `-${this.param}` : "";
      return `vac-icon-${this.name}${param}`;
    },
    size() {
      const item = this.svgItem[this.name];
      if (item.size === "large") return 512;
      else if (item.size === "medium") return 48;
      else return 24;
    },
  },
};
</script>

<style lang="scss">
#vac-icon-search {
  fill: var(--chat-icon-color-search);
}
#vac-icon-add {
  fill: var(--chat-icon-color-add);
}
#vac-icon-toggle {
  fill: var(--chat-icon-color-toggle);
}
#vac-icon-menu {
  fill: var(--chat-icon-color-menu);
}
#vac-icon-close {
  fill: var(--chat-icon-color-close);
}
#vac-icon-close-image {
  fill: var(--chat-icon-color-close-image);
}
#vac-icon-file {
  fill: var(--chat-icon-color-file);
}
#vac-icon-paperclip {
  fill: var(--chat-icon-color-paperclip);
}
#vac-icon-close-outline {
  fill: var(--chat-icon-color-close-outline);
}
#vac-icon-send {
  fill: var(--chat-icon-color-send);
}
#vac-icon-send-disabled {
  fill: var(--chat-icon-color-send-disabled);
}
#vac-icon-emoji {
  fill: var(--chat-icon-color-emoji);
}
#vac-icon-emoji-reaction {
  fill: var(--chat-icon-color-emoji-reaction);
}
#vac-icon-document {
  fill: var(--chat-icon-color-document);
}
#vac-icon-pencil {
  fill: var(--chat-icon-color-pencil);
}
#vac-icon-checkmark,
#vac-icon-double-checkmark {
  fill: var(--chat-icon-color-checkmark);
}
#vac-icon-checkmark-seen,
#vac-icon-double-checkmark-seen {
  fill: var(--chat-icon-color-checkmark-seen);
}
#vac-icon-eye {
  fill: var(--chat-icon-color-eye);
}
#vac-icon-dropdown-message {
  fill: var(--chat-icon-color-dropdown-message);
}
#vac-icon-dropdown-room {
  fill: var(--chat-icon-color-dropdown-room);
}
#vac-icon-dropdown-scroll {
  fill: var(--chat-icon-color-dropdown-scroll);
}
#vac-icon-audio-play {
  fill: var(--chat-icon-color-audio-play);
}
#vac-icon-audio-pause {
  fill: var(--chat-icon-color-audio-pause);
}
</style>